import { useEffect, useState } from 'react';
export const useIsScrolled = () => {
  const _useState = useState(window.scrollY > 0),
    isScrolled = _useState[0],
    setIsScrolled = _useState[1];
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return isScrolled;
};
//# sourceMappingURL=useIsScrolled.js.map